import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from "@angular/router";

const helper = new JwtHelperService();

@Injectable({
  providedIn: "root"
})
export class StateService {
  isLogin = false;
  drones = 0;
  username;
  decodedToken;
  expirationDate: Date;
  isExpired: boolean;

  pilotList: any[] = [];

  constructor(private router: Router) {}

  validateLogin() {
    let myRawToken = localStorage.getItem("token");
    if (myRawToken) {
      this.decodedToken = helper.decodeToken(myRawToken);
      // console.log(this.decodedToken);
      this.expirationDate = helper.getTokenExpirationDate(myRawToken);
      this.isExpired = helper.isTokenExpired(myRawToken);
      if (!this.isExpired) {
        this.isLogin = true;
        this.username = this.decodedToken.data.username;
        this.drones = Number(this.decodedToken.data.drones);
        return true;
      } else {
        this.isLogin = false;
        this.router.navigate(["/login"]);
        return false;
      }
    } else {
      this.isLogin = false;
      this.router.navigate(["/login"]);
      return false;
    }
  }
}
